import { JSX } from 'react'

import { IconProps } from '../../icon'

const Downloaded: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M39.2692 28.0513C38.5964 28.0513 38.0385 28.6092 38.0385 29.2821V34.2051C38.0385 35.3374 37.1195 36.2564 35.9872 36.2564H13.0128C11.8805 36.2564 10.9615 35.3374 10.9615 34.2051V29.2821C10.9615 28.6092 10.4036 28.0513 9.73077 28.0513C9.05795 28.0513 8.5 28.6092 8.5 29.2821V34.2051C8.5 36.6995 10.5185 38.718 13.0128 38.718H35.9872C38.4815 38.718 40.5 36.6995 40.5 34.2051V29.2821C40.5 28.6092 39.9421 28.0513 39.2692 28.0513Z'
      fill='black'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M32.1876 16.3124C32.6041 16.729 32.6041 17.4044 32.1876 17.8209L22.9431 27.0653C22.5266 27.4819 21.8512 27.4819 21.4347 27.0653L16.8124 22.4431C16.3959 22.0266 16.3959 21.3512 16.8124 20.9347C17.229 20.5181 17.9044 20.5181 18.3209 20.9347L22.1889 24.8026L30.6792 16.3124C31.0957 15.8959 31.771 15.8959 32.1876 16.3124Z'
      fill='black'
    />
  </svg>
)

export default Downloaded
